import { useProposalData } from '../../../../../hooks/populate-data/use-proposal-data';
import ProposalContentModal from './proposal-content-modal';
import { TypeOfActionProposal } from '../../../../../types/type';
import LoadingState from '../../../../ui/loadibg-state';
import ErrorState from '../../../../ui/error-state';
import { useDispatch } from 'react-redux';
import CloseButtonModal from '../../../../ui/close-button-modal';
import { clearProposalId, clearTypeModal, clearTypeOfProposalStatus, clearUpdateTypeModal } from '../../../../../features/gms-state-and-modal/modal-slice';
import { resetBasicInformation } from '../../../../../features/gms-proposal-forms/basic-information/basic-information.slice';
import { setCurrentStep } from '../../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import { resetAllRates, resetRates } from '../../../../../features/actuarial/rates-slice';
import { resetProposalForm } from '../../../../../helper/proposal/proposal-reset-form';

interface Props {
    typeOfIcon: TypeOfActionProposal
}

export default function ProposalActionModal({ typeOfIcon }: Props) {

    const dispatch = useDispatch();
    const { isLoadingProposal, isErrorProposal, proposalErrorMessage } = useProposalData()
    const handleCloseUpdateProposalModal = () => {
        dispatch(clearUpdateTypeModal());
        dispatch(resetBasicInformation());
        dispatch(clearProposalId());
        dispatch(clearTypeOfProposalStatus());
        dispatch(clearTypeModal());
        dispatch(setCurrentStep(1));
        dispatch(resetRates())
        dispatch(resetAllRates())
        resetProposalForm(dispatch);
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-2 sm:p-4">
            <div className="flex h-[96dvh] w-full flex-col overflow-hidden rounded-xl bg-white shadow-2xl sm:max-w-[90vw] 2xl:h-[82dvh] lg:max-w-[700px] xl:max-w-[800px] 2xl:max-w-[1000px]">
                <div className="flex shrink-0 items-center justify-between border-b border-white/10 bg-[#186cb2] px-4 py-3 md:px-5 md:py-4 lg:px-6">
                    <div className="min-w-0">
                        <p className="truncate text-sm font-semibold leading-tight text-white">
                            Proposal Data
                        </p>
                        <p className="mt-1 truncate text-[11px] leading-tight text-white/90 md:text-xs">
                            Explore and review proposal information.
                        </p>
                    </div>
                    <div className="ml-3 flex shrink-0 items-center justify-end">
                        <CloseButtonModal isLoading={isLoadingProposal} handleClose={handleCloseUpdateProposalModal} />
                    </div>
                </div>
                {isLoadingProposal ? (
                    <LoadingState />
                ) : isErrorProposal ? (
                    <ErrorState description={proposalErrorMessage} />
                ) : ( 
                    <ProposalContentModal typeOfIcon={typeOfIcon} />
                )}
            </div>
        </div>
    )
}
